module.exports = __webpack_public_path__ + "img/title-2.3f00cd13.png";